import { render, staticRenderFns } from "./MTab.vue?vue&type=template&id=414d7e96&scoped=true"
import script from "./MTab.vue?vue&type=script&lang=js"
export * from "./MTab.vue?vue&type=script&lang=js"
import style0 from "./MTab.vue?vue&type=style&index=0&id=414d7e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d7e96",
  null
  
)

export default component.exports